import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const messagesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/messages",
  component: lazyRouteComponent(() => import("./messages.page.js"), "MessagesPage"),
});
